import React from "react"

// Img
import imgAzusa from "../../assets/img/logo_azusa.png"

const LogoAzusa = () => {
  return <img src={imgAzusa} alt="AZUSA SEKKEI" />
}

export default LogoAzusa